export const ENDPOINTS = {
  check: 'check',
};
